






















helpers = require('../../helpers.coffee')

view_model = {
  components:
    specificTemplateListItem: require('./list_item')

  props:
    flow:
      required: true

    contact:
      required: true
}

exports.default = view_model




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/specific_templates/list.vue